var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPanel',{attrs:{"headline":"Create Content Topic Article","errors":_vm.errors,"portal":_vm.portal},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }